<template>
  <div
    id="profile-score"
    class="has-text-right"
  >
    <div class="score is-inline">
      <h6 class="title is-6 is-inline tooltip" data-tooltip="This is only visible to you.">
        Profile Score
        &nbsp;
        <span
          class="is-size-5 total-score"
          :class="getScoreColor(generateProfileScore(profile).score)"
        >{{ generateProfileScore(profile).score }}</span>
      </h6>
    </div>
    <div v-if="generateProfileScore(profile).tipsForImprovement.length > 0">
      <div class="tip-button">
        <p
          class="button is-rounded is-small is-black is-outlined"
          @click="toggleTips"
        >
          <i
            class="fas fa-sm"
            :class="tipsAreExpanded ? 'fa-minus' : 'fa-plus'"
          />
        </p>
        <small class="tip-button-text is-vcentered">See tips to improve your score</small>
      </div>
    </div>
    <section
      v-if="tipsAreExpanded"
      class="section no-pad-left-right has-text-left"
    >
      <ProfileTips :tips="generateProfileScore(profile).tipsForImprovement" />
    </section>
  </div>
</template>

<script>
import generateProfileScore from '@/helpers/generateProfileScore';
import ProfileTips from '@/components/CandidateProfile/ProfileTips';

export default {
  name: 'ProfileScore',
  components: {
    ProfileTips
  },
  data () {
    return {
      tipsAreExpanded: false
    };
  },
  computed: {
    profile () {
      return this.$store.state.user.profile;
    }
  },
  methods: {
    generateProfileScore: generateProfileScore,
    getScoreColor (score) {
      if (score < 50) {
        return 'is-danger';
      } else if (score < 75) {
        return 'is-danger';
      } else if (score <= 100) {
        return 'is-success';
      }
    },
    toggleTips () {
      this.tipsAreExpanded = !this.tipsAreExpanded;
    }
  }
};
</script>

<style lang="scss" scoped>
#profile-score {
  margin-top: 1rem;
  .section {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .score {
    display: flex;
    align-items: center;
    h6 {
      cursor: pointer;
    }
  }
}

@media screen and (min-width: 769px) {
  .tip-column {
    text-align: right !important;
  }
}

.tip-button-text {
  margin-left: 0.5rem;
  position: relative;
  top: 0.4rem;
}

.tip-button {
  margin-top: 0.5rem;
}

.total-score {
  padding-right: 1rem;
  &:after {
    content: "";
    position: absolute;
    height: 0.6rem;
    width: 0.6rem;
    top: 0.25rem;
    right: 0;
    border-radius: 100px;
  }

  &.is-danger {
    &:after {
      background-color: $danger;
    }
  }

  &.is-success {
    &:after {
      background-color: $success;
    }
  }
}
</style>
